import { UnitProfile } from "@/models/unitProfile";
import { defineStore } from "pinia";
import {
  getUnitProfileInfo,
  getUnitProfileInfoFromContextId,
} from "@/services/statsService";

export interface IUnitProfileState {
  selectedUnitProfile: UnitProfile;
}

export const useUnitProfileStore = defineStore("unitProfileStore", {
  state: (): IUnitProfileState => ({
    selectedUnitProfile: new UnitProfile(),
  }),

  actions: {
    async getUnitProfileWithContextId(
      questionnaireId: string,
      contextId: string
    ): Promise<void> {
      try {
        const unit = await getUnitProfileInfoFromContextId(
          questionnaireId,
          contextId
        );
        this.setUnitProfileData(unit);
      } catch (error) {
        throw new Error("Could not get unit profile information");
      }
    },

    async getUnitProfileWithTrustGroupId(
      questionnaireId: string,
      trustGroupId: string
    ): Promise<void> {
      try {
        const unit = await getUnitProfileInfo(questionnaireId, trustGroupId);
        this.setUnitProfileData(unit);
      } catch (error) {
        throw new Error("Could not get unit profile information");
      }
    },

    setUnitProfileData(unit: any): void {
      this.selectedUnitProfile.basicCompanyInfo.companyName =
        unit.company.companyName;
      this.selectedUnitProfile.basicCompanyInfo.organisationNumber =
        unit.company.organisationNumber;
      this.selectedUnitProfile.basicCompanyInfo.operatingCountryCode =
        unit.company.operatingCountryCode;
      this.selectedUnitProfile.basicCompanyInfo.industry =
        unit.company.industry;

      this.selectedUnitProfile.tierLevel = unit.tier;
      this.selectedUnitProfile.companyAddress = unit.companyAddress;
      this.selectedUnitProfile.risks = unit.risks;
      this.selectedUnitProfile.questionnaireResponses =
        unit.questionnaireResponses;

      this.selectedUnitProfile.countriesOfOperation = unit.countriesOfOperation;

      this.selectedUnitProfile.contactPerson = unit.contactPerson;
    },
  },
});
